import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { SafeHtml } from "@angular/platform-browser";

export interface ContactMessage {
    name: string;
    email: string;
    phone: string;
    section: string;
    topic: string;
    message: SafeHtml;
}

@Injectable({
    providedIn: "root",
})
export class ContactMessageService {
    private baseUrl = environment.apiUrl;
    private endpointBase = "/api/ContactMessage/";

    constructor(private http: HttpClient) {}

    addContactMessage(
        contactMessage: ContactMessage
    ): Observable<ContactMessage> {
        return this.http.post<ContactMessage>(
            `${this.baseUrl}${this.endpointBase}create_contact_message`,
            contactMessage,
            {
                headers: new HttpHeaders({
                    "Content-Type": "application/json",
                }),
            }
        );
    }

    //   getAllContactMessages(): Observable<ContactMessage[]> {
    //     return this.http.get<ContactMessage[]>(this.apiUrl);
    //   }
}
